import { createStyles } from '@material-ui/core/styles';

const styles = () =>
  createStyles({
    root: {
      fill: 'transparent',
    },
  });

export default styles;
